/** Decode SSE data frames across byte/UTF-8 boundaries. */
export async function* readSSEData(stream) {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let completed = false;
    const dataFrom = (frame) => {
        const lines = frame.split(/\r?\n/).filter(line => line.startsWith('data:'));
        if (!lines.length)
            return undefined;
        return lines.map(line => line.slice(5).replace(/^ /, '')).join('\n');
    };
    try {
        while (true) {
            const { done, value } = await reader.read();
            buffer += done ? decoder.decode() : decoder.decode(value, { stream: true });
            let separator;
            while ((separator = buffer.match(/\r?\n\r?\n/))) {
                const index = separator.index;
                const frame = buffer.slice(0, index);
                buffer = buffer.slice(index + separator[0].length);
                const data = dataFrom(frame);
                if (data !== undefined)
                    yield data;
            }
            if (done) {
                completed = true;
                const data = dataFrom(buffer);
                if (data !== undefined)
                    yield data;
                return;
            }
        }
    }
    finally {
        if (!completed)
            await reader.cancel().catch(() => { });
        reader.releaseLock();
    }
}
